import React, { useState, useEffect } from "react";

// Package Import
import { Typography, Box, useTheme, Grid, Paper, Chip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
// import { App as CapacitorApp } from "@capacitor/app";

// User Import

import Barchart from "../../../shared/Barchart";
import {
  GlobeBlueIcon,
  ProfileIcon,
  PopulationServedIcon,
  InventoryIcon,
  HashIcon,
  UnitsDeliveredIcon,
  ExpiredDosesIcon,
  WastedDosesIcon,
  DomainIcon,
  EmailIcon,
  TempratureIcon,
  BatchIcon1,
} from "../../../../Svg";
import { RoutesUrls, adminRoutes } from "../../../../Services/Routes/APP";
import { headersPost } from "../../../../Services/API";
import { MINISTRY_API_ULRS } from "../../../../Services/Routes/API";
import { format } from "date-fns";
// Component

const Details = () => {
  // Hooks

  const theme = useTheme();

  const { state } = useLocation();
  const navigate = useNavigate();

  // States
  const [barChartData, setBarChartData] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");

  // vaccination details for barchart
  const getVaccinationDetails = () => {
    const data = {
      details_request: {
        view_level: "ministry",
        view_level_id: state?.node?.id,
      },
    };

    headersPost(MINISTRY_API_ULRS.GET_DASHBOARD_DATA, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setBarChartData(res.data?.barChartData);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.admin + adminRoutes?.detailsMinistry);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const yearSixMonthsAgo = () => {
    let d = new Date();
    d.setMonth(d.getMonth() - 6);
    return d.getFullYear();
  };

  const currentYear = () => {
    let d = new Date();
    return d.getFullYear();
  };

  // life cycle

  useEffect(() => {
    getVaccinationDetails();
  }, [state]);

  return (
    <Box>
      <Grid
        container
        spacing={2}
        sx={{
          overflow: { xs: "hidden", sm: "hidden", md: "hidden", lg: "hidden" },
        }}
      >
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6} alignItems={"stretch"}>
          <Paper>
            <Box padding={{ xs: 1, sm: 2 }}>
              <Typography variant="h6" component="div">
                General information
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {state?.node?.name}
              </Typography>
              {/* 1 ROW */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <GlobeBlueIcon />
                  </Box>
                  <Typography
                    ml={2}
                    sx={{ paddingTop: 1.8, textAlign: "left" }}
                  >
                    Country
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.name}
                  />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <ProfileIcon />
                  </Box>
                  <Typography ml={2} sx={{ paddingTop: 1.8 }}>
                    Population
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.population || 0}
                  />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <PopulationServedIcon />
                  </Box>
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Population Served
                    </Typography>

                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated at{" "}
                      {state?.node?.updated_at
                        ? format(new Date(), "MM/dd/yyyy")
                        : ""}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.vaccinated || 0}
                  />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <InventoryIcon />
                  </Box>{" "}
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Current Inventory
                    </Typography>
                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label="1000 Units"
                  />
                </Box>
              </Grid>
            </Box>
          </Paper>
          {barChartData && (
            <Grid item mt={2}>
              <Paper>
                <Box padding={{ xs: 1, sm: 2 }}>
                  <Typography variant="h5">Monthly Overview</Typography>
                  <Typography variant="p" color={"text.grayText"}>
                    Population Served per month
                  </Typography>
                  <Barchart data={barChartData} />
                  <Typography
                    variant="body2"
                    textAlign={"center"}
                    style={{ marginTop: "25px" }}
                  >
                    {yearSixMonthsAgo == currentYear
                      ? `Year ${currentYear()}`
                      : `Year ${yearSixMonthsAgo()} - ${currentYear()}`}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={6}
          height={"-webkit-fill-available"}
        >
          {/* <Grid container padding={2}> */}
          <Paper>
            <Box
              padding={{ xs: 1, sm: 2 }}
              // minWidth={{ xs: 300, sm: 780, lg: "400px" }}
            >
              <Typography variant="h6" component="div">
                Inventory information
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {state?.node?.name}
              </Typography>
              {/* 1 ROW */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <HashIcon />
                  </Box>
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Vaccine Batch
                    </Typography>

                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Current
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.reference_number || "N/A"}
                  />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <BatchIcon1 />
                  </Box>
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Batch Received
                    </Typography>

                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Current Batch
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={
                      state?.node?.received_date
                        ? format(new Date(), "MM/dd/yyyy")
                        : "MM/dd/yyyy"
                    }
                  />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <BatchIcon1 />
                  </Box>
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Batch Expiry
                    </Typography>

                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Current Batch
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={
                      state?.node?.expiry_date
                        ? format(new Date(), "MM/dd/yyyy")
                        : "MM/dd/yyyy"
                    }
                  />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <TempratureIcon />
                  </Box>{" "}
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Storage Temprature
                    </Typography>
                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.storage_temperature || "N/A"}
                  />
                </Box>
              </Grid>
              {/* 5th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <UnitsDeliveredIcon />
                  </Box>{" "}
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Units Delivered
                    </Typography>
                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.quantity_received || 0}
                  />
                </Box>
              </Grid>
              {/* 6th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <ExpiredDosesIcon />
                  </Box>{" "}
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Expired Doses
                    </Typography>
                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.quantity_expired || 0}
                  />
                </Box>
              </Grid>
              {/* 7th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <WastedDosesIcon />
                  </Box>{" "}
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Damaged Doses
                    </Typography>
                    <Typography
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.quantity_damage || 0}
                  />
                </Box>
              </Grid>
              {/* 8th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <EmailIcon />
                  </Box>{" "}
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Email
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.email || "N/A"}
                  />
                </Box>
              </Grid>
              {/* 9th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <DomainIcon />
                  </Box>{" "}
                  <Box ml={2}>
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Domain
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      borderRadius: 1,
                    }}
                    label={state?.node?.domain || "N/A"}
                  />
                </Box>
              </Grid>
            </Box>
          </Paper>
          {/* </Grid> */}
        </Grid>
      </Grid>

      {/* <Grid item xs={8} ms={12}>
    <h1>This is Grid</h1>
  </Grid> */}
    </Box>
  );
};

export default Details;
